import AntdForm from 'antd/es/form';
import Form from './Form';
import Item from './FormItem';

export type AntdFormType = typeof AntdForm;

const AntdFormType: AntdFormType = Object.assign({}, AntdForm, Form, { Item });

export default AntdFormType;

export type { FormInstance } from 'antd/es/form';
